import api from './axiosInstance';

// User identity (creation/deletion) is owned by Portal now — this module only
// manages role (local ADMIN/USER bypass) and Group assignment for people
// Portal has already synced in.
export const getAll = () => api.get('/users');
export const getById = (id) => api.get(`/users/${id}`);
export const update = (id, data) => api.put(`/users/${id}`, data);
